import React from "react";

import { useGetCompanyDags } from "api/api-hooks/airflow-hooks";
import { Card } from "primereact/card";
import AirflowDagList from "./components/AirflowDagList";

const Airflow: React.FC = () => {
  const { data, isLoading } = useGetCompanyDags();

  return (
    <Card title="Airflow DAGs">
      <AirflowDagList data={data ?? []} loading={isLoading} />
    </Card>
  );
};

export default Airflow;
